import { get, request } from "core-web/libs/GrebbCommerceAPI/util";

import { API_URL } from "core-web/constants";
import { getModel } from "core-web/state";

export default async (applicationId, url) => {
    const path = "/frontend/categories/tree";
    if (!API_URL && url) {
        const response = await request({
            method: "GET",
            path: `${path}?application_id=${applicationId}`,
            baseUrl: url,
        });
        if (response) {
            return await response.body();
        }
    }

    const response = await get(path, {
        application_id: applicationId || getModel("application").applicationId,
    });

    return await response.body();
};
